import React, { useEffect, useCallback } from "react";
import { connect } from "react-redux";

import spinner from "../../assets/images/loadingGif.gif";

import { DataGrid, GridToolbar } from "@mui/x-data-grid";

import {
  getMalwareScanLogs,
  clearAllMalwareScanLogsMessages,
} from "../../store/actions";

import { SnackbarProvider, enqueueSnackbar } from "notistack";

// const transformData = (apiData) => {
//   console.log("apiData", apiData);
//   const transformedData = [];

//   apiData.forEach( item => {
//     const key = item.key;
//     const obj = { key };

//     item.content.forEach(contentItem => {
//       const contentKey = contentItem[0];
//       const contentValue = contentItem[1];
//       obj[contentKey] = contentValue;
//     });
//     transformedData.push(obj);
//   });

//   return transformedData;
// }

const columns = [
  // { field: "key", headerName: "Kay", width: 300 },
  { field: "file_name", headerName: "File Name", width: 300 },
  // { field: "file_path", headerName: "File Path", width: 200 },
  { field: "malware_detected", headerName: "Malware Detected", width: 150 },
  { field: "org_code", headerName: "Org Code", width: 150 },
  { field: "timestamp", headerName: "Timestamp", width: 300 },
  { field: "username", headerName: "Username", width: 300 },
  { field: "uuid", headerName: "UUID", width: 300 },
];

const MalwareScan = (props) => {
  console.log("props: ", props);

  const clearAllMessages = useCallback(() => {
    props.clearAllMessages();
  }, []);


  const malwareLogs = props.malwareLogs;
  useEffect(() => {
    if(!malwareLogs){
      props.getMalwareScanLogs();
    }
  }, [malwareLogs]);

  //For displaying message for getting malware scan logs
  let getMalwareScanLogsMessage = props.getMalwareScanLogsMessage;
  let getMalwareScanLogsError = props.getMalwareScanLogsError;
  useEffect(() => {
    console.log("getMalwareScanLogsMessage = " + getMalwareScanLogsMessage);
    if (getMalwareScanLogsMessage || getMalwareScanLogsError) {
      console.log("Inside if, getMalwareScanLogsMessage = " + getMalwareScanLogsMessage);
      clearAllMessages();
      // setTimeout(() => {
      //   props.clearAllMessages();
      // }, 10000); // Hide all messages after 10 seconds
      if(getMalwareScanLogsMessage){
        enqueueSnackbar(getMalwareScanLogsMessage, {variant: "success"});
      }
      if(getMalwareScanLogsError){
        enqueueSnackbar(getMalwareScanLogsError, {variant: "error"});
      }
    }
  }, [getMalwareScanLogsMessage, getMalwareScanLogsError, clearAllMessages]);

  return (
    <div>
      <SnackbarProvider />
      <h1>Malware Scan</h1>
      {props.malwareScanLogsGetting && (
          <div
            style={{
              display: "flex",
              direction: "column",
              alignContent: "center",
              alignItems: "center",
              justifyContent: "center",
              justifyItems: "center",
              height: "100vh",
            }}
          >
            <img src={spinner} width="32px" alt="Spinner" />
          </div>
      )}
      {props.malwareLogs && (
          <DataGrid
            rows={props.malwareLogs}
            columns={columns}
            pageSize={5}
            components={{
              Toolbar: GridToolbar,
            }}
            disableSelectionOnClick
            autoHeight
            disableColumnMenu
            disableColumnSelector
            getRowId={(row) => row.key}
            initialState={{
              pagination: {
                paginationModel: { pageSize: 10, page: 0 },
              },
            }}
            density="compact"
          />
        )}

    </div>
  )
}


const mapStateToProps = (state) => {
  const {
    malwareLogs,
    malwareScanLogsGetting,
    getMalwareScanLogsMessage,
    getMalwareScanLogsError
  } = state.malwareScan;

  return {
    malwareLogs,
    malwareScanLogsGetting,
    getMalwareScanLogsMessage,
    getMalwareScanLogsError
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getMalwareScanLogs: () => {
      dispatch(getMalwareScanLogs());
    },
    clearAllMessages: () => {
      dispatch(clearAllMalwareScanLogsMessages());
    },
  };
};

export default connect(mapStateToProps,mapDispatchToProps)(MalwareScan);
